import { forEach, pick } from "lodash";
import ThumborUrlBuilder from "@interencheres/thumbor-url-buider";
import crypto from "crypto-js";
import { MediaTransform, thor } from "../../typings/thor";

class RewriteUrlImgService {
    public static $inject: string[] = ["configService"];

    private static authorizedMetas = ["brightness", "contrast", "saturation", "sharpen", "rotate", "crop"];

    constructor(private configService) {}

    private static hashFn = (stringToHash, secret) => {
        const key = crypto.HmacSHA1(stringToHash, secret);
        const hash = crypto.enc.Base64.stringify(key);
        return hash.replace(/\+/g, "-").replace(/\//g, "_");
    };

    /**
     * This method tells you if a rotation has been made which change the aspect ratio
     * This can be tested before a resizing to avoid image to be stretched
     * @param transform MediaTransform
     * @return boolean, Is the image aspect ratio has changed
     */
    private static _isAspectRatioChanged(transform: MediaTransform): boolean {
        return (
            transform.rotate &&
            (transform.rotate === 90 ||
                transform.rotate === -90 ||
                transform.rotate === 270 ||
                transform.rotate === -270)
        );
    }

    public buildUrl(mediaUrl, rewriteParameters: thor.RewriteUrlImgParameters) {
        const parameters = angular.copy(rewriteParameters);
        const parser = document.createElement("a");
        parser.href = mediaUrl;
        const { host } = parser;

        let transform: MediaTransform = {};
        if (parameters.transform) {
            transform = <MediaTransform>pick(parameters.transform, RewriteUrlImgService.authorizedMetas);
        }

        let resizerHost: string;
        if (this.configService.resizeDomainPrefix === "" || this.configService.resizeDomainPrefix == null) {
            resizerHost = host;
        } else {
            resizerHost = `${this.configService.resizeDomainPrefix}.${host}`;
        }

        const builder = new ThumborUrlBuilder(
            "//" + resizerHost,
            this.configService.thumborSecret,
            RewriteUrlImgService.hashFn
        );

        builder.setImagePath(parser.pathname);

        if (transform.crop) {
            builder.crop(
                transform.crop.left,
                transform.crop.top,
                transform.crop.right,
                transform.crop.bottom
            );

            delete transform.crop;
        }

        if (this._formatFilters(transform)) {
            builder.filter(this._formatFilters(transform));
        }

        if (parameters.width && parameters.height) {
            const width = RewriteUrlImgService._isAspectRatioChanged(transform) ? parameters.height : parameters.width;
            const height = RewriteUrlImgService._isAspectRatioChanged(transform) ? parameters.width : parameters.height;

            builder.resize(width, height);

            if (parameters.cropMode === "fullFitIn") {
                builder.fullFitIn(width, height);
            }
            if (parameters.cropMode === "smart") {
                builder.smartCrop(true);
            }
        }

        return builder.buildUrl();
    }

    private _formatFilters(filters) {
        const formattedFilters = [];
        forEach(
            filters,
            (filterValue, filterName) => {
                switch (filterName) {
                    case "saturation":
                        if (filterValue !== 1) {
                            formattedFilters.push(`${ filterName }(${ filterValue })`);
                        }
                        break;
                    case "sharpen":
                        if (filterValue.amount !== 0) {
                            formattedFilters.push(
                                `${ filterName }(${ filterValue.amount },${ filterValue.radius },true)`
                            );
                        }
                        break;
                    default:
                        if (filterValue !== 0 && filterValue !== null) {
                            formattedFilters.push(`${ filterName }(${ filterValue })`);
                        }
                        break;
                }
            });

        return formattedFilters.join(":");
    }
}

angular
    .module("thor.core.images.rewriteUrlImg.service", [])
    .service("rewriteUrlImg", RewriteUrlImgService);
